import { useAccount, useBalance, useReadContract } from "wagmi";
import { swappingContractsConfig } from "@config/contractsConfig";

const useSwapTokensBalances = (chainId: number) => {
  const { isConnected, address } = useAccount();
  // const { swapConfig } = useDappConfig();
  const { rsETH = null, wrsETH = null } =
    isConnected && chainId && swappingContractsConfig[chainId]?.tokens
      ? swappingContractsConfig[chainId].tokens
      : {};

  const { data: rsETHBalance, refetch: refetchRsETHBalance } = useBalance({
    address,
    token: rsETH?.address,
    query: {
      enabled: isConnected,
      refetchInterval: 10_000,
    },
    chainId: chainId,
  });

  const { data: rsETHAllowance, refetch: refetchRsETHAllowance } =
    useReadContract({
      address: rsETH?.address,
      abi: rsETH?.abi,
      functionName: "allowance",
      args: [address, wrsETH?.address],
      query: {
        enabled: isConnected,
        refetchInterval: 10_000,
      },
      chainId: chainId,
    });

  const { data: wrsETHBalance, refetch: refetchWrsETHBalance } = useBalance({
    token: wrsETH?.address,
    address,
    query: {
      enabled: isConnected,
      refetchInterval: 10_000,
    },
    chainId: chainId,
  });

  const { data: wrsETHAllowance, refetch: refetchWrsETHAllowance } =
    useReadContract({
      address: wrsETH?.address,
      abi: wrsETH?.abi,
      functionName: "allowance",
      args: [address, wrsETH?.address],
      query: {
        enabled: isConnected,
        refetchInterval: 10_000,
      },
      chainId: chainId,
    });

  const invalidateCache = () => {
    refetchRsETHBalance();
    refetchRsETHAllowance();
    refetchWrsETHBalance();
    refetchWrsETHAllowance();
  };

  return {
    rsETHBalance: rsETHBalance?.value || 0n,
    wrsETHBalance: wrsETHBalance?.value || 0n,
    rsETHAllowance: (rsETHAllowance as bigint) || 0n,
    wrsETHAllowance: (wrsETHAllowance as bigint) || 0n,
    invalidateCache,
  };
};

export default useSwapTokensBalances;
